import Vue from 'vue'

const state = {
  token: null,
  role: null,
  user: null
}

const mutations = {
  SET_USER_TOKEN (state, token) {
    let _token

    try {
      _token = JSON.parse(localStorage.getItem('token'))
    } catch (e) {
      localStorage.removeItem('token')
      _token = null
    }

    state.token = _token
  },
  SET_USER_DETAILS (state) {
    let _userDetails

    try {
      _userDetails = JSON.parse(localStorage.getItem('user_details'))
    } catch (e) {
      localStorage.removeItem('user_details')
      _userDetails = null
    }

    state.user = _userDetails
  },
  LOGOUT (state) {
    localStorage.removeItem('token')
    localStorage.removeItem('user_details')
    state.token = null
    state.role = null
    state.user = null
    state.audits = []
  }
}

const actions = {
  login ({ commit }, { email, password }) {
    return new Promise((resolve, reject) => {
      Vue.axios.post(`${window.config.apiUrl}jwt/AuthUser`,
        {
          Email: email,
          Password: password
        })
        .then(response => {
          if (response.data !== '') {
            // Save Token on local storage
            localStorage.setItem('token', JSON.stringify(response.data.token))
            localStorage.setItem('user_details', JSON.stringify(response.data.user_details))

            // Set user details to state.user
            commit('SET_USER_DETAILS')

            // Set Token to state.user.token
            commit('SET_USER_TOKEN')
            resolve(response)
          } else {
            reject(new Error('Authentication failed!'))
          }
        })
        .catch(error => {
          localStorage.removeItem('token')
          localStorage.removeItem('user_details')
          reject(error)
        })
    })
  },
  logout ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('LOGOUT')
      resolve()
    })
  },
  setUserToken ({ commit }) {
    commit('SET_USER_TOKEN')
  },
  setUserRole ({ commit }) {
    if (localStorage.getItem('user_details') === null) return
    state.role = JSON.parse(localStorage.getItem('user_details')).roles[0].name
  },
  requestPasswordReset ({ commit }, email) {
    return new Promise((resolve, reject) => {
      Vue.axios.post(`${window.config.apiUrl}Users/RequestPasswordReset`,
        {
          Email: email
        })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          localStorage.removeItem('token')
          localStorage.removeItem('user_details')
          reject(error)
        })
    })
  },
  setNewPassword ({ commit }, user) {
    return new Promise((resolve, reject) => {
      Vue.axios.post(`${window.config.apiUrl}Users/SetNewPassword`, user)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateNotificationConfig ({ state, commit, rootState }) {
    /* TODO: We might need to update this function in the future in order to reuse it for other notifications */

    // Get current user
    var user = JSON.parse(localStorage.getItem('user_details'))

    // Get new value to be set. Since it's a new value, users that were already logged in before this new feature was deployed,
    // won't have the notificationsConfig object in their user_details object.
    // For this reason, we need to set the new value as 'true' since this notification config will be set as 'false' by default.
    var newNotificationValue = typeof user.notificationsConfig === 'undefined' || user.notificationsConfig === null ? false : !user.notificationsConfig[0].optIn

    return new Promise((resolve, reject) => {
      Vue.axios.post(`${window.config.apiUrl}Users/UpdateNotificationsConfig`,
        {
          notificationsConfig: [
            {
              /* notificationTypeId: 11, */
              optIn: newNotificationValue
            }
          ]
        })
        .then(response => {
          // Update optIn value
          user.notificationsConfig = [
            {
              /* id: 11, */
              optIn: newNotificationValue
            }
          ]

          // Update local storage
          localStorage.setItem('user_details', JSON.stringify(user))

          // Set state.user
          commit('SET_USER_DETAILS')
          resolve(response)
        })
        .catch(error => {
          alert(`Something went wrong, we couldn't update your settings.`)
          console.error(error)
          reject(error)
        })
    })
  }
}

const getters = {
  loggedUser () {
    return state.user || JSON.parse(localStorage.getItem('user_details'))
  },
  token () {
    return state.token ? 'Bearer ' + state.token.access_token : null
  },
  getAuthenticationHeader () {
    return state.token ? { 'Authorization': 'Bearer ' + state.token.access_token } : null
  },
  getUserRole () {
    return state.role
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js